/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketssalesended2Inputs */

const en_ticketssalesended2 = /** @type {(inputs: Ticketssalesended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales ended`)
};

const de_ticketssalesended2 = /** @type {(inputs: Ticketssalesended2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauf beendet`)
};

/**
* | output |
* | --- |
* | "Sales ended" |
*
* @param {Ticketssalesended2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssalesended2 = /** @type {((inputs?: Ticketssalesended2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssalesended2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssalesended2(inputs)
	return de_ticketssalesended2(inputs)
});
export { ticketssalesended2 as "ticketsSalesEnded" }